export default __webpack_public_path__ + "static/media/3350.33d361e8.png";